import ScheduleCalendar from './ScheduleCalendar';
import { TabsWrap } from './tabs.style';
import { Tabs } from 'lib/ui';
import React from 'react';

const StaffTabs = ({ provider, newDesign }) => {
  // DT speciality -> new redesigned calendar; other specialities -> old tabbed view.
  if (newDesign) {
    return (
      <TabsWrap>
        <ScheduleCalendar provider={provider} mode="template" />
      </TabsWrap>
    );
  }
  return (
    <TabsWrap>
      <Tabs
        type="card"
        panes={[
          {
            title: '',
            content: <ScheduleCalendar provider={provider} mode="legacy" />
          }
        ]}
      />
    </TabsWrap>
  );
};

export default React.memo(StaffTabs);
